import type { RouteObject } from 'react-router-dom';

/**
 * The 15-day free trial, public (outside the signed-in shell):
 *   /demo   name, email, gym name → "check your inbox" (TrialSignupPage)
 * The emailed link comes back to /login (#…type=invite), which asks for a password.
 */
export const trialRoutes: RouteObject[] = [
  { path: 'demo', lazy: async () => ({ Component: (await import('./TrialSignupPage')).TrialSignupPage }) },
];
